import { hasValidAddress } from '@snootsvet/shared/portal'

import { useGetMe } from '@/customer/hooks/use-get-me'
import { hasOnboardedPet, type OnboardingIssue } from '@/customer/lib/membership'
import { routes } from '@/customer/routes'

export function useOnboardingIssues(): { issues: OnboardingIssue[]; isPending: boolean } {
  const me = useGetMe()

  if (me.isPending || !me.data) return { issues: [], isPending: true }

  const { member, patients } = me.data
  const hasCompletedPetOnboarding = hasOnboardedPet(patients)
  const hasAnyPet = patients.length > 0
  const issues: OnboardingIssue[] = []

  if (!member.phone) {
    issues.push({
      type: 'missing_phone',
      title: 'Add a phone number',
      description: 'So we can send appointment reminders and confirm bookings.',
      action: { href: routes.account.phone.update },
    })
  } else if (!member.phoneVerified) {
    issues.push({
      type: 'unverified_phone',
      title: 'Verify your phone number',
      description: 'So we can send appointment reminders and confirm bookings.',
      action: { href: routes.account.phone.verify },
    })
  }

  if (!hasValidAddress(member)) {
    issues.push({
      type: 'invalid_address',
      title: 'Confirm your home address',
      description: 'We need a valid physical address on file to prescribe medication.',
      action: { href: routes.account.profile },
    })
  }

  if (!hasCompletedPetOnboarding) {
    issues.push({
      type: 'no_onboarded_pet',
      title: hasAnyPet ? 'Finish registering your pet' : 'Register a pet',
      description: hasAnyPet
        ? 'Pick a plan to activate their membership.'
        : "Add your pet's details to continue.",
      action: { href: hasAnyPet ? routes.account.pets.index : routes.account.pets.add },
    })
  }

  return { issues, isPending: false }
}
